// Local development only (http://localhost): keep the Privy SDK on auth.privy.io.
//
// The Privy app has the custom auth domain privy.instaswap.com. As soon as the SDK reads
// `custom_api_url` from the app config it switches to that domain AND to cookie-based sessions
// (the refresh token lives in an HttpOnly cookie on *.instaswap.com). From localhost that cookie
// is cross-site and never readable, so right after a successful login `getAccessToken()` finds no
// refresh credentials, wipes the local session and returns null: "Your sign-in session expired".
// Production (partners.instaswap.com) is same-site and unaffected. Here we strip the custom domain
// from the app-config response so localhost keeps localStorage sessions on auth.privy.io.
const isLocalDev =
  process.env.NODE_ENV === "development" &&
  typeof window !== "undefined" &&
  /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);

if (isLocalDev && typeof window.fetch === "function") {
  const nativeFetch = window.fetch.bind(window);
  const appConfigUrl = /^https:\/\/auth\.privy\.io\/api\/v1\/apps\/[^/?#]+\/?(\?.*)?$/;
  window.fetch = async (input, init) => {
    const url = typeof input === "string" ? input : input?.url || "";
    const res = await nativeFetch(input, init);
    if (!appConfigUrl.test(url) || !res.ok) return res;
    try {
      const body = await res.clone().json();
      if (!body || !body.custom_api_url) return res;
      const patched = { ...body, custom_api_url: null };
      // eslint-disable-next-line no-console
      console.info("[privyLocalDev] custom auth domain disabled on localhost (sessions stay in localStorage)");
      return new Response(JSON.stringify(patched), { status: res.status, statusText: res.statusText, headers: res.headers });
    } catch (_) {
      return res;
    }
  };
}

export default isLocalDev;
